<script lang="typescript">
    import Loader from "shared/loader.svelte";
    import Form from "shared/form.svelte";
    import Input from "shared/input.svelte";
    import Switch from "shared/switch.svelte";
    import List from "shared/list.svelte";

    import Sheet from "shared/sheet.svelte";
    import Expander from "shared/expander.svelte";
    import Header from "../components/header.svelte";
    import SectionSubHeader from "../components/section-subheader.svelte";
    import Subtitle2 from "shared/typography/subtitle2.svelte";
    import Caption from "shared/typography/caption.svelte";

    import Button from "shared/button.svelte";
    import * as ApiService from "../services/api.service";

    let rules: Rule[] = [];
    let jorneys: Journey[] = [];
    let conditions: RuleCondition[] = [];

    let reportFileList: ReportFile[] = [];
    let reportFileSelected: ReportFile = undefined;

    let selectedRuleList: RuleReport[] = [];
    let reports: Reports = undefined;
    let selectedRule: RuleReport = undefined;
    let selectedManagers: ManagerReport[] = [];

    let status = "";
    import {
        AnomalyIcon,
        NotificationIcon,
        ReportIcon,
        RuleIcon,
    } from "../components/icons";
    import { onMount } from "svelte";
    import { TimelineDialog } from "./dialogs";
    import type { Marks } from "src/components/charts/timeline";
    import { RuleUtils, to } from "src/utils";
    import { ModalSystem } from "shared/systems";

    let isListProcessing = false;
    let isRuleProcessing = false;

    let sleep = (delay: number) =>
        new Promise((resolve, _) => {
            setTimeout(resolve, delay);
        });

    const fetchLists = async () => {
        isListProcessing = true;
        status = "Atualizando listas...";

        let [errList, newReportFileList] = await to(ApiService.getReportList());
        if (errList) {
            status = "Erro ao tentar carregar a lista de regras";
            return;
        }

        let [errCond, newConditions] = await to(ApiService.getConditions());
        if (errCond) {
            status = "Erro ao tentar carregar a lista de condições";
            return;
        }

        conditions = newConditions.map((c) => {
            c.icon = RuleUtils.getConditionIcon(c.value);
            return c;
        });
        reportFileList = newReportFileList;

        if (reportFileList.length > 0) {
            selectReportFile(reportFileList[0]);
        }

        isListProcessing = false;
        status = "";
    };

    const onSelectReportFile = (e: any) => {
        const { selected } = e.detail;
        selectReportFile(selected);
    };

    const selectReportFile = async (reportFile: ReportFile) => {
        isRuleProcessing = true;
        status = "carregando relatórios...";
        selectedManagers = [];
        let [errReport, newReport] = await to(
            ApiService.getReport(reportFile.id)
        );
        if (errReport) {
            status = "Erro ao tentar carregar o relatório " + reportFile.id;
            return;
        }
        reportFileSelected = reportFile;

        selectedRuleList = Object.keys(newReport.rules).map(
            (k) => newReport.rules[k]
        );

        if (selectedRuleList.length > 0) {
            selectRule(selectedRuleList[0]);
        }
        isRuleProcessing = false;
    };

    const onSelectRule = (e: any) => {
        const { selected } = e.detail;
        selectRule(selected);
    };
    const selectRule = (rule: RuleReport) => {
        selectedRule = rule;
        selectedManagers = Object.keys(selectedRule.managers).map(
            (k) => selectedRule.managers[k]
        );
    };

    const openAccess = async (
        ruleReport: RuleReport,
        jorney: JorneyReport,
        employee: EmployeeReport
    ) => {
        console.log({ employee });

        const newJorney: Journey = {
            name: jorney.journeyName,
            start: jorney.journeyStart,
            end: jorney.journeyEnd,
            cod: 0,
        };

        const newRule: Rule = {
            condition: ruleReport.ruleCondition as any,
            description: ruleReport.ruleDescription,
            device: ruleReport.ruleDevice,
            id: ruleReport.ruleId,
            journeySize: 0,
            deviceStart: ruleReport.ruleDeviceStart,
            deviceEnd: ruleReport.ruleDeviceEnd,
            title: ruleReport.ruleTitle,
            rules: ruleReport.rules,
            recursiveProcess: false,
            notification: ruleReport.notification,
            journeys: [jorney.journeyName],
            deviceToleranceMinutes: ruleReport.ruleDeviceToleranceMinutes,
            startRule: ruleReport.ruleStart,
            endRule: ruleReport.ruleEnd,
            startProcess: ruleReport.processStart,
            endProcess: ruleReport.processEnd,
        };

        let marks = employee.accesses.map((e) => {
            let timeOnly = e.datetime.split(" ")[1];
            let mark: Marks = {
                name: e.device,
                time: timeOnly,
                color: RuleUtils.getMarkColor(e, newRule),
            };

            return mark;
        });

        const timelineResult = await ModalSystem.show<Journey>({
            component: TimelineDialog,
            props: {
                name: employee.name,
                conditions,
                rule: newRule,
                bars: RuleUtils.getRuleBars(newRule, newJorney, conditions),
                marks,
            },
            parameters: { size: "medium", canClose: true },
        });
    };

    onMount(async () => {
        await fetchLists();
    });
</script>

<div class="rules-view">
    <div class="content">
        <Header
            title="Anomalias Encontradas"
            subtitle="Visualizar os logs de processamento do serviço"
        />
        <div class="columns ">
            <!-- Report Files-->
            <div class="rows mr-16 list-files">
                <SectionSubHeader
                    color="var(--color-level-6)"
                    icon={ReportIcon}
                    title="Lista de Arquivos"
                />

                <Sheet>
                    <div class="buttons">
                        {#if isListProcessing || isRuleProcessing}
                            <div class="status">
                                <Loader size={36} />
                                <Subtitle2
                                    text={status}
                                    style="padding: 0 16px;"
                                />
                            </div>
                        {/if}
                    </div>

                    {#if !isListProcessing}
                        <List
                            selected={reportFileSelected}
                            items={reportFileList}
                            on:select={onSelectReportFile}
                        >
                            <div
                                slot="item"
                                class="list-item"
                                let:item
                                let:active
                            >
                                <span class="item-icon">
                                    <svelte:component
                                        this={ReportIcon}
                                        width={24}
                                        height={24}
                                        color="var(--color-level-5)"
                                    />
                                </span>

                                <div class="list-info rows">
                                    <Subtitle2
                                        text={item.date}
                                        color={active
                                            ? "var(--color-primary)"
                                            : "var(--color-level-7)"}
                                    />
                                    <Caption
                                        text={item.time}
                                        color="var(--color-level-5)"
                                    />
                                </div>
                            </div>
                        </List>
                    {/if}
                </Sheet>
            </div>

            <!-- Ruless -->
            <div class="rows mr-16 list-rules">
                <SectionSubHeader
                    color="var(--color-warning)"
                    icon={AnomalyIcon}
                    title="Lista de Relatórios"
                />

                <Sheet style="overflow-y: auto;">
                    {#if !isRuleProcessing && !isListProcessing}
                        <List
                            items={selectedRuleList}
                            selected={selectedRule}
                            on:select={onSelectRule}
                        >
                            <div
                                slot="item"
                                class="list-item"
                                let:item
                                let:active
                            >
                                <span class="item-icon">
                                    <svelte:component
                                        this={RuleUtils.getConditionIcon(item.ruleCondition)}
                                        width={24}
                                        height={24}
                                        color="var(--color-alert)"
                                    />
                                </span>

                                <div class="list-info rows">
                                    <Subtitle2
                                        text={item.ruleTitle}
                                        color={active
                                            ? "var(--color-primary)"
                                            : "var(--color-level-7)"}
                                    />
                                    <Caption
                                        text={item.ruleDescription}
                                        color="var(--color-level-5)"
                                    />
                                </div>
                            </div>
                        </List>
                    {/if}
                </Sheet>
            </div>

            <!-- Time line -->
            <div class="rows timeline">
                <SectionSubHeader
                    color="var(--color-alert)"
                    icon={RuleIcon}
                    title="Detalhes do Envio"
                />
                <Sheet style=" width: 100%; overflow-y: auto;">
                    {#if selectedManagers}
                        {#each selectedManagers as manager}
                            <Expander
                                header={manager.managerName}
                                headerStyle="color: var(--color-primary); "
                            >
                                <div class="row row-4">
                                    <span class="label">Nome:</span>
                                    <span class="value"
                                        >{manager.managerName}</span
                                    >
                                    <span class="label">Cargo:</span>
                                    <span class="value"
                                        >{manager.managerPost}</span
                                    >
                                    <span class="label">E-mail:</span>
                                    <span class="value"
                                        >{manager.managerEmail}</span
                                    >
                                    <span class="label">Telefone:</span>
                                    <span class="value"
                                        >{manager.managerPhone}</span
                                    >
                                    <span class="label">
                                        <svelte:component
                                            this={NotificationIcon}
                                            width={24}
                                            height={24}
                                            color="var(--color-level-4)"
                                        />
                                    </span>
                                    <span
                                        class="value"
                                        style="grid-column: 2 / 5;"
                                        >Noticações</span
                                    >

                                    {#each manager.notificationReports as report}
                                        <span class="label">Tipo:</span>
                                        <span class="value"
                                            >{report.sendKind}</span
                                        >

                                        <span class="label">Status:</span>
                                        <span
                                            class="value {report.result
                                                ? 'success'
                                                : 'alert'}"
                                            >{report.result
                                                ? "Sucesso"
                                                : report.error}</span
                                        >
                                    {/each}

                                    <span
                                        class="label"
                                        style="
                            grid-column: 1 / 5;
                            justify-content: flex-start;
                            color: var(--color-warning);
                            "
                                        >Supervisores</span
                                    >

                                    {#each Object.keys(manager.supervisors).map((k) => manager.supervisors[k]) as supervisor}
                                        <Expander
                                            header={supervisor.supervisorName}
                                            style=" grid-column: 1 / 5;"
                                            headerStyle="color: var(--color-warning); "
                                        >
                                            <div class="row row-4">
                                                <span class="label">Nome:</span>
                                                <span
                                                    class="value"
                                                    style="grid-column: 2 / 5;"
                                                    >{supervisor.supervisorName}</span
                                                >

                                                <span class="label"
                                                    >Jornada:</span
                                                >
                                                <span class="value"
                                                    >{supervisor.journey
                                                        .journeyName}</span
                                                >

                                                <span class="label"
                                                    >Horário</span
                                                >
                                                <span class="value"
                                                    >{supervisor.journey
                                                        .journeyStart}-{supervisor
                                                        .journey
                                                        .journeyEnd}</span
                                                >

                                                <span
                                                    class="value"
                                                    style="grid-column: 2 / 5;"
                                                    >Noticações</span
                                                >

                                                {#each supervisor.notificationReports as sReport}
                                                    <span class="label"
                                                        >Tipo:</span
                                                    >
                                                    <span class="value"
                                                        >{sReport.sendKind}</span
                                                    >

                                                    <span class="label"
                                                        >Status:</span
                                                    >
                                                    <span
                                                        class="value {sReport.result
                                                            ? 'success'
                                                            : 'alert'}"
                                                        >{sReport.result
                                                            ? "Sucesso"
                                                            : sReport.error}</span
                                                    >
                                                {/each}

                                                <span
                                                    class="label"
                                                    style="
                                    grid-column: 1 / 5;
                                    justify-content: flex-start;
                                    color: var(--color-success);
                                    "
                                                    >Colaboradores</span
                                                >

                                                {#each supervisor.journey.employees as empoloyee}
                                                    <Expander
                                                        header={empoloyee.name}
                                                        style=" grid-column: 1 / 5;"
                                                        headerStyle="color: var(--color-success); "
                                                    >
                                                        <div class="row row-4">
                                                            <span class="label"
                                                                >Nome:</span
                                                            >
                                                            <span class="value"
                                                                >{empoloyee.name}</span
                                                            >
                                                            <Button
                                                                text="acessos"
                                                                on:click={() =>
                                                                    openAccess(
                                                                        selectedRule,
                                                                        supervisor.journey,
                                                                        empoloyee
                                                                    )}
                                                            />
                                                        </div>
                                                    </Expander>
                                                {/each}
                                            </div>
                                        </Expander>
                                    {/each}
                                </div>
                            </Expander>
                        {/each}
                    {/if}
                </Sheet>
            </div>
        </div>
    </div>
</div>

<style>
    .rules-view {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        /* padding: 0 10%; */
        align-items: center;
        overflow: auto;
    }
    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 16px;
    }
    .columns {
        display: flex;
        flex-direction: row;
        /* flex-wrap: wrap; */
        height: 100%;
        overflow: hidden;
    }

    .rows {
        display: flex;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
    }

    .buttons {
        height: 48px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: var(--color-level-2);
    }

    .row {
        grid-template-columns: auto 1fr;
        display: grid;
        column-gap: 16px;
        margin-bottom: 8px;
    }

    .row-4 {
        grid-template-columns: 1fr 2fr 1fr 2fr;
        grid-template-rows: min-content;
        row-gap: 8px;
        padding: 16px;
        grid-auto-rows: minmax(16px, auto);
        background: var(--color-level-1);
    }

    .label {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: var(--color-level-3);
        font-size: 14px;
    }
    .value {
        display: flex;

        align-items: center;
        color: var(--color-level-5);
        font-size: 14px;
    }

    .timeline {
        width: auto;
        flex-grow: 1;
    }

    .mr-16 {
        margin-right: 16px;
    }

    .list-files {
        width: 300px;
        flex-shrink: 0;
    }
    .list-rules {
        width: 400px;
        flex-shrink: 0;
    }
    .list-info {
        width: 100%;
        justify-content: center;
    }
    .list-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        /* padding: 0 16px; */
        border-bottom: 1px solid var(--color-level-3);
    }

    .item-icon {
        height: 100%;
        padding: 0 16px;
        display: flex;
        align-items: center;
    }

    /* TODO make this a component */
    .status {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 32px;
        align-items: center;
        padding: 0 16px;
    }

    .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    .success {
        color: var(--color-success);
    }
    .alert {
        color: var(--color-alert);
    }
</style>
